// Imports
import React, { useCallback, useEffect } from "react";

// Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

// Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager, NotificationContainer } from "Components/Notifications";
// Actions
import { workOrderDeleteCustomer, reset } from "./redux/slice";

const DeleteCustomer = ({ refresh, single }) => {

    //Redux
    const dispatch = useDispatch();
    const { open, loading, result, error, customer, customerList } = useSelector((state) => state.workOrdersDeleteCustomerRedux);

    //Language
    const { messages } = useIntl();

    //Handlers and utils
    const handleClose = useCallback(() => dispatch(reset()), []);

    //Effects
    useEffect(() => {
        if (error) {
            let errorMessage = messages["errorMessage"];
            const errorLower = error?.error?.toLowerCase();
            if (errorLower.includes('are in use')) {
                errorMessage = messages['manage_deleteCustomers_are_in_use']
            }
            NotificationManager.error(
                errorMessage,
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ error: null }));
        }
    }, [error]);

    useEffect(() => {
        if (!result) return;
        if (result?.delete) {
            const messageSuccess = customer
                ? messages['manage_deleteCustomer_successMessage']
                : messages['manage_deleteCustomers_successMessage'];

            NotificationManager.success(
                messageSuccess,
                messages["success"],
                3000,
                null,
                null,
                "success"
            );
            refresh && refresh();
            dispatch(reset());
        } else {
            NotificationManager.error(
                messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ result: null }));
        }
    }, [result]);

    return (
        <Modal
            title={customer ? single ? `${messages['manage_deleteCustomer_title']} ${customer?.name ? ` "${customer?.name}"` : ''}` : messages['manage_deleteCustomer_title'] : messages['manage_deleteCustomers_title']}
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={() => {
                            if (customer) {
                                dispatch(workOrderDeleteCustomer({ ids: [customer?.id] }));
                            }
                            if (customerList?.length) {
                                let ids = customerList.map((item) => item?.id)
                                dispatch(workOrderDeleteCustomer({ ids: ids }));
                            }
                        }}
                        isDisabled={loading}
                    >
                        {messages["delete"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "10px 25px" }}>
                <p>{customer ? messages['manage_deleteCustomer_description'] : messages['manage_deleteCustomers_description']}</p>
                {
                    !single && (
                        <ul>
                            {customer ? (
                                <li style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                    {customer?.name}
                                </li>
                            ) : (
                                customerList?.map((crew, index) => (
                                    <li key={index} style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                        {crew.name}
                                    </li>
                                ))
                            )}
                        </ul>
                    )
                }
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default DeleteCustomer;